// Cookie consent (WHIT-421). Analytics and advertising trackers (Google tag,
// Meta pixel) may load only after the visitor accepts; the privacy policy
// promises exactly that. Plain CommonJS so `node --test` can run the tests.

const CONSENT_COOKIE = 'cookie_consent';
// The earlier Accept-only banner stored `authorize`; keep honouring it.
const LEGACY_ACCEPT_COOKIE = 'authorize';
const CHOICES = ['accepted', 'rejected'];
const TRACKING_COOKIE = /^(_ga|_gid|_gat|_fbp|_fbc)(_|$)/;

const parseConsentChoice = value => (CHOICES.includes(value) ? value : null);

// `cookies` maps cookie names to values, as sent with the request.
const readConsent = cookies => {
  if (cookies[CONSENT_COOKIE] !== undefined)
    return parseConsentChoice(cookies[CONSENT_COOKIE]);
  return cookies[LEGACY_ACCEPT_COOKIE] !== undefined ? 'accepted' : null;
};

const trackingAllowed = consent => consent === 'accepted';

// Names of the Google Analytics and Meta cookies in a `document.cookie` string.
const trackingCookieNames = documentCookie =>
  documentCookie
    .split(';')
    .map(part => part.split('=')[0].trim())
    .filter(name => TRACKING_COOKIE.test(name));

// Domains to clear a cookie on: host-only, the host, and every parent down to
// the registrable domain. Trackers write to the widest domain they can
// (.allmyles.com for showcase.allmyles.com).
const cookieDomains = hostname => {
  const labels = hostname.split('.');
  if (labels.length < 2) return ['', hostname];
  const parents = [];
  for (let i = 0; i <= labels.length - 2; i += 1)
    parents.push(`.${labels.slice(i).join('.')}`);
  return ['', hostname, ...parents];
};

module.exports = {
  cookieDomains,
  CONSENT_COOKIE,
  LEGACY_ACCEPT_COOKIE,
  parseConsentChoice,
  readConsent,
  trackingAllowed,
  trackingCookieNames,
};
